<template functional>
  <SmartRow class="px-3">
    <div
      v-for="loading in 2"
      :key="`${loading}-loading-1`"
      class="lg:col-12">
      <SmartSkeletonLoading
        class="mb-1 block lg:col-4"
        :height="2"
      />
      <SmartSkeletonLoading
        class="mb-4 block lg:col-7"
        :height="3"
      />
    </div>

    <div
      v-for="loading in 4"
      :key="`${loading}-loading-2`"
      class="lg:col-4 inline-block">
      <SmartSkeletonLoading
        class="mb-1 block lg:col-6"
        :height="2"
      />
      <SmartSkeletonLoading
        class="mb-4 block lg:col-12"
        :height="3"
      />
    </div>

    <div class="lg:col-12">
      <SmartSkeletonLoading
        class="mb-1 block lg:col-4"
        :height="2"
      />
    </div>
    <div
      v-for="loading in 4"
      :key="`${loading}-loading-3`"
      class="lg:col-3 inline-block">
      <SmartSkeletonLoading
        class="mb-4 mx-2"
        :height="3"
      />
    </div>

    <div
      v-for="loading in 10"
      :key="`${loading}-loading-4`"
      class="lg:col-12 inline-block">
      <SmartSkeletonLoading
        class="mx-2"
        :class="props.randomSize(2, 5)"
        :height="2"
      />
      <SmartSkeletonLoading
        class="mb-4 mx-2"
        :class="props.randomSize(4, 6)"
        :height="3"
      />
    </div>
  </SmartRow>
</template>

<script>
// @flow
export default {
  props: {
    randomSize: {
      type: Function,
      default: (min: number, max: number): string => {
        min = Math.ceil(min);
        max = Math.floor(max);
        const randomNum = Math.floor(Math.random() * (max - min + 1) + min);

        return `lg:col-${randomNum}`;
      }
    }
  }
};
</script>
